/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconCopy/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconCopy({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconCopy",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  height = 24,
  width = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconCopy.Svg"
  data-view-path={viewPath}
 viewBox="0 -960 960 960"
 style={{'--as-1-HhBj': alignSelf,'--mt-2-HhBj': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-HhBj': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-HhBj': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-HhBj': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-HhBj': opacity,'--h-10-HhBj': typeof height === 'number' ? `${height}px` : height,'--w-11-HhBj': typeof width === 'number' ? `${width}px` : width,'--a-7-HhBj': isAnimated ? animation : "none",'--sd-8-HhBj': isAnimated ? strokeDashoffset : 0,'--sd-9-HhBj': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconCopy.SvgPath"
  data-view-path={viewPath}
 d="M200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200zm160-160q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360zm0-80h360v-480H360v480zm0 0v-480 480z"
 style={{'--f-12-HhBj': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}